import { Component, OnInit, inject } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ProblemInstanceService, PatientService } from 'planner-shared';

@Component({
    selector: 'app-patients-overview',
    templateUrl: './patients-overview.component.html',
    styleUrls: ['./patients-overview.component.scss'],
    standalone: false
})
export class PatientsOverviewComponent implements OnInit {
    private readonly problemInstanceService = inject(ProblemInstanceService);
    private readonly patientService = inject(PatientService);

    public totalPatientTasks: number;
    public tasksWithoutMainResponsibles: number;
    public totalPatientTasksContainsWarnings: number;
    public totalPatientTasksContainsErrors: number;
    public loadingPatientsInfoCount: boolean;
    public loadingPatientTasksInfoCount: boolean;

    ngOnInit(): void {
        this.loadingPatientsInfoCount = true;
        this.loadingPatientTasksInfoCount = true;

        this.problemInstanceService.getProblemInstance().subscribe(result => {
            this.totalPatientTasks = result.problemInstance.tasks.length;
            this.tasksWithoutMainResponsibles = result.problemInstance.officeInfo.numberOfTasksWithoutMainResponsibles;
            this.loadingPatientsInfoCount = false;
        });

        this.loadPatientTasksInfoCount().subscribe();
    }

    public loadPatientTasksInfoCount(): Observable<void> {
        return forkJoin([
            this.patientService.getPatients().pipe(
                tap(patients => {
                    this.totalPatientTasksContainsWarnings = patients.reduce(
                        (accumulator, patient) => accumulator + patient.tasksFeasibilityWarningCount,
                        0
                    );
                    this.totalPatientTasksContainsErrors = patients.reduce(
                        (accumulator, patient) => accumulator + patient.tasksFeasibilityErrorCount,
                        0
                    );
                    this.loadingPatientTasksInfoCount = false;
                })
            ),
            this.problemInstanceService
                .getProblemInstance()
                .pipe(
                    tap(
                        result =>
                            (this.tasksWithoutMainResponsibles =
                                result.problemInstance.officeInfo.numberOfTasksWithoutMainResponsibles)
                    )
                )
        ]).pipe(map(() => null));
    }
}
